// extracted by mini-css-extract-plugin
export default {"cart":"CartMain_cart__2i3ru","headerAndBody":"CartMain_headerAndBody__ZaGFM","cartItems":"CartMain_cartItems__e63Aq"};